import { Compass } from 'lucide-react'
import { EmptyState, LinkButton } from '@/components/ui'
import { useT } from '@/internationalization/i18n'

export function NotFoundPage() {
  const t = useT()
  return (
    <EmptyState
      icon={<Compass />}
      title={t('notFound.title')}
      description={t('notFound.body')}
      action={
        <LinkButton to="/" variant="primary">
          {t('notFound.back')}
        </LinkButton>
      }
    />
  )
}
